import { unit } from '@ant-design/cssinjs';
import { genRoundedArrow } from './roundedArrow';
export const MAX_VERTICAL_CONTENT_RADIUS = 8;
export function getArrowOffsetToken(options) {
  const {
    contentRadius,
    limitVerticalRadius
  } = options;
  const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
  const arrowOffsetVertical = limitVerticalRadius ? MAX_VERTICAL_CONTENT_RADIUS : arrowOffset;
  return {
    arrowOffsetHorizontal: arrowOffset,
    arrowOffsetVertical
  };
}
function isInject(valid, code) {
  if (!valid) {
    return {};
  }
  return code;
}
export default function getArrowStyle(token, colorBg, options) {
  const {
    componentCls,
    boxShadowPopoverArrow,
    arrowOffsetVertical,
    arrowOffsetHorizontal
  } = token;
  const {
    arrowDistance = 0,
    arrowPlacement = {
      left: true,
      right: true,
      top: true,
      bottom: true
    }
  } = options || {};
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      ["".concat(componentCls, "-arrow")]: [Object.assign(Object.assign({
        position: 'absolute',
        zIndex: 1,
        display: 'block'
      }, genRoundedArrow(token, colorBg, boxShadowPopoverArrow)), {
        '&:before': {
          background: colorBg
        }
      })]
    }, isInject(!!arrowPlacement.top, {
      [["&-placement-top > ".concat(componentCls, "-arrow"), "&-placement-topLeft > ".concat(componentCls, "-arrow"), "&-placement-topRight > ".concat(componentCls, "-arrow")].join(',')]: {
        bottom: arrowDistance,
        transform: 'translateY(100%) rotate(180deg)'
      },
      ["&-placement-top > ".concat(componentCls, "-arrow")]: {
        left: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
      },
      '&-placement-topLeft': {
        '--arrow-offset-horizontal': arrowOffsetHorizontal,
        ["> ".concat(componentCls, "-arrow")]: {
          left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      },
      '&-placement-topRight': {
        '--arrow-offset-horizontal': "calc(100% - ".concat(unit(arrowOffsetHorizontal), ")"),
        ["> ".concat(componentCls, "-arrow")]: {
          right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      }
    })), isInject(!!arrowPlacement.bottom, {
      [["&-placement-bottom > ".concat(componentCls, "-arrow"), "&-placement-bottomLeft > ".concat(componentCls, "-arrow"), "&-placement-bottomRight > ".concat(componentCls, "-arrow")].join(',')]: {
        top: arrowDistance,
        transform: "translateY(-100%)"
      },
      ["&-placement-bottom > ".concat(componentCls, "-arrow")]: {
        left: {
          _skip_check_: true,
          value: '50%'
        },
        transform: "translateX(-50%) translateY(-100%)"
      },
      '&-placement-bottomLeft': {
        '--arrow-offset-horizontal': arrowOffsetHorizontal,
        ["> ".concat(componentCls, "-arrow")]: {
          left: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      },
      '&-placement-bottomRight': {
        '--arrow-offset-horizontal': "calc(100% - ".concat(unit(arrowOffsetHorizontal), ")"),
        ["> ".concat(componentCls, "-arrow")]: {
          right: {
            _skip_check_: true,
            value: arrowOffsetHorizontal
          }
        }
      }
    })), isInject(!!arrowPlacement.left, {
      [["&-placement-left > ".concat(componentCls, "-arrow"), "&-placement-leftTop > ".concat(componentCls, "-arrow"), "&-placement-leftBottom > ".concat(componentCls, "-arrow")].join(',')]: {
        right: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: 'translateX(100%) rotate(90deg)'
      },
      ["&-placement-left > ".concat(componentCls, "-arrow")]: {
        top: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
      },
      ["&-placement-leftTop > ".concat(componentCls, "-arrow")]: {
        top: arrowOffsetVertical
      },
      ["&-placement-leftBottom > ".concat(componentCls, "-arrow")]: {
        bottom: arrowOffsetVertical
      }
    })), isInject(!!arrowPlacement.right, {
      [["&-placement-right > ".concat(componentCls, "-arrow"), "&-placement-rightTop > ".concat(componentCls, "-arrow"), "&-placement-rightBottom > ".concat(componentCls, "-arrow")].join(',')]: {
        left: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: 'translateX(-100%) rotate(-90deg)'
      },
      ["&-placement-right > ".concat(componentCls, "-arrow")]: {
        top: {
          _skip_check_: true,
          value: '50%'
        },
        transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
      },
      ["&-placement-rightTop > ".concat(componentCls, "-arrow")]: {
        top: arrowOffsetVertical
      },
      ["&-placement-rightBottom > ".concat(componentCls, "-arrow")]: {
        bottom: arrowOffsetVertical
      }
    }))
  };
}